import styled, { css } from 'styled-components';

type WrapperProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  $small?: boolean;
  $textDarkLighten?: boolean;
  $fullWidth?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  --font-size: ${(props) => props.theme.font.size.regular};
  --line-height: ${(props) => props.theme.font.lineHeight.main};
  --margin-block: 1em;

  font-size: var(--font-size);
  line-height: var(--line-height);
  max-width: ${(props) => props.theme.distances.contentMaxWidth};

  & > :is(#important, :first-child) {
    margin-top: 0;
  }

  & > :is(#important, :last-child) {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: calc(var(--margin-block) * 2);
    margin-bottom: var(--margin-block);
  }

  p:not([class]) {
    margin: var(--margin-block) 0;
  }

  a:not([class]) {
    color: var(--c-link);
  }

  & :where(p:not([class]), ul:not([class]), ol:not([class])) {
    margin: var(--margin-block) 0;
  }

  & :where(ul:not([class]), ol:not([class])) {
    padding-left: 2.5em;
  }

  li:not([class]) {
    & + li {
      margin-top: 0.25em;
    }

    &::marker {
      color: var(--c-text-muted);
    }
  }

  ${({ $small }) =>
    $small &&
    css`
      --font-size: ${(props) => props.theme.font.size.small};
    `}

  ${({ $textDarkLighten }) =>
    $textDarkLighten &&
    css`
      color: var(--c-text-muted);
    `}

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      max-width: none;
    `}
`;
